import { memoryStore, useStore } from "../../../lib/store";

// True between Firebase auth flip and the corresponding /webapp/public/users
// POST completing. `useCurrentUser` gates on this to avoid firing
// GET /webapp/private/users/me with a uid that has no DB row yet.
export const signupInFlightStore = memoryStore<boolean>(false);

export function useSignupInFlight(): boolean {
  const [value] = useStore(signupInFlightStore);
  return value;
}
